export const portfolio_history_graph = `query portfolio_history_graph($input: HistoryQuery!){
    portfolio_history_graph(input: $input){
        value
        percent
        points{
            value
            time
        }
    }
}`;
